// extracted by mini-css-extract-plugin
module.exports = {"rollDiceContainer":"RollDice_rollDiceContainer__7HxFd","rollDiceHeading":"RollDice_rollDiceHeading__2F6Ei"};